var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-close",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 0c282.304 0 512 229.696 512 512s-229.696 512-512 512-512-229.696-512-512 229.696-512 512-512z m0 128C300.224 128 128 300.224 128 512s172.224 384 384 384 384-172.224 384-384-172.224-384-384-384zM338.752 338.752a63.936 63.936 0 0 1 90.496 0L512 421.504l82.752-82.752a63.936 63.936 0 1 1 90.496 90.496L602.496 512l82.752 82.752a63.936 63.936 0 1 1-90.496 90.496L512 602.496l-82.752 82.752a63.808 63.808 0 0 1-90.496 0 63.936 63.936 0 0 1 0-90.496L421.504 512 338.752 429.248a63.936 63.936 0 0 1 0-90.496z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7e3af4ce9560860c5e9dacc3dc7a2d71.svg";
export { ForwardRef as ReactComponent };